import {vnTemplate} from "../../../../valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {validationsList_template} from "../../../../valnet_jslib/vnKnockoutJsTemplates/validationsList_template";


declare var ko: any;

export default class videoPickerAdd_template extends vnTemplate {


    public validations: validationsList_template;

    public parent: any

    setParent(value: any) {
        this.parent = value;
    }

    protected initPartial(): void {

        this.validations = new validationsList_template("validationList_add", this.getTemplateViewModel(), this.caller);
    }

    protected buildViewModel(): any {
        const viewModel = {
            videoPickerAddShown: ko.observable(false),
            uploadIsInProgress: ko.observable(false),
            uploadValue: ko.observable(0),
            uploadValueMax: ko.observable(100),
            videoBlob : ko.observable(null),
            videoIsNotUploadable : ko.observable(false),
            fileIsVideo : ko.observable(true),

            onClickCancel : () => this.onClickCancel(),
            onAddVideoFiles : (data, event) => this.onAddVideoFiles(data, event),
            onDropVideoFiles : (data, event) => this.onDropVideoFiles(data, event),
            onClickUploadVideos : () => this.onClickUploadVideos(),
        }

        return viewModel
    }

    protected getTemplateName(): string {
        return "videoPickerAdd-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    protected getTemplateHtml(): string {
        return (`
<div class="w-img-picker-form" data-bind="css: { 'is-visible': videoPickerAddShown } ">
    <div class="img-picker-form" >
        <div class="form-header">
            <h3 class="section-title">Add a new video</h3>
            <button type="button" class="close-btn icon i-close" data-bind="event: { click: onClickCancel }" ></button>
        </div>

        <div class="form-body vertical-center center-content">
            <progress id="progress-bar" data-bind="attr : {value : uploadValue , max : uploadValueMax }"></progress>
<!--            <div style="color:red" data-bind="visible: uploadError">ERROR OCCURRED UPLOADING FILE</div>-->
        </div>

        <div class="form-body vertical-center center-content">
            ${this.validations.getHtmlBuild()}
            <div class="form-group">
                <div class="from-droparea" id="drop-area" data-bind=" event: { drop: onDropVideoFiles }"></div>
            </div>
            <div class="form-group">
                <span class="form-text">or</span>
            </div>
            <div class="form-group">
                <input type="file" id="videoFileElement" name="videoFileElement" accept="video/mp4" data-bind="event: { change: onAddVideoFiles }"  hidden>
                <button type="button" class="btn dark" id="_upload-video-button" data-bind="click : onClickUploadVideos">Select videos</button>
            </div>
        </div>
    </div>
</div>
`);
    }

    /* Action */

    toggleModal() {
        this.getTemplateViewModel().videoPickerAddShown(!this.getTemplateViewModel().videoPickerAddShown())
    }

    show(){
        this.getTemplateViewModel().videoPickerAddShown(true)
    }

    hide(){
        this.validations.clearMessages()
        this.getTemplateViewModel().videoPickerAddShown(false)
        this.clearVideoFileInput()
    }

    isShown(){
        return this.getTemplateViewModel().videoPickerAddShown() === true
    }

    onClickCancel(): any {
        this.hide()
    }

    onDropVideoFiles(data, event): any {
        this.validations.clearMessages()
        event.stopPropagation();
        event.preventDefault();

        const dt = event.dataTransfer;
        const files = dt.files;
        document.getElementById('videoFileElement')["files"] = files
        this.getVideoFilesInfosForPreview(files);
    }
    onAddVideoFiles(data, event): any {
        const files = event.target.files;
        this.getVideoFilesInfosForPreview(files);
    }

    onClickUploadVideos(){
        this.validations.clearMessages()
        const inputVideoUpload = document.getElementById('videoFileElement')
        //Invoque the input video click event
        inputVideoUpload.click()
    }

    async getVideoFilesInfosForPreview(files) {
        try {
            const { duration, size , isVideo } = await this.getVideoMetaData(files[0])
            let proportion = Math.trunc(duration / 60) + 1
            let sizeLimit = proportion * 157286400; // 150MB in bytes (1024 * 1024 * 150)

            this.setFileIsVideo(isVideo)
            if(size > sizeLimit){
                if (confirm("The video file size exceeds 150MB per minute of video. This is not recommended given the associated cost. Do you accept the additional cost and want to proceed with the upload?") === false) {
                    this.setVideoIsNotUploadable(true)
                }
            }

        }catch (e) {
            const { duration, size , isVideo } = e
            this.setFileIsVideo(isVideo)
        }

        this.caller.handleVideoUpload(files)
    }

    setUploadIsInProgress(value){
        this.getTemplateViewModel().uploadIsInProgress(value)
    }

    setUploadValue(value): any {
        this.getTemplateViewModel().uploadValue(value)
    }

    clearVideoFileInput(){
        const inputVideoUpload = document.getElementById('videoFileElement') as HTMLInputElement
        inputVideoUpload.value = ""
        this.setVideoIsNotUploadable(false)
        this.setFileIsVideo(true)
        URL.revokeObjectURL(this.getVideoBlob())
        this.setVideoBlob(null)

    }

    async getVideoMetaData(file) : Promise<any>{

        const url = URL.createObjectURL(file)
        return new Promise((resolve, reject) => {
            if(file.type.indexOf('video') != -1){
                this.setVideoBlob(url)
                const video = document.createElement("video")
                const source = document.createElement("source");
                source.src = url;
                video.preload = "metadata";
                video.appendChild(source);
                video.onloadedmetadata = function(){
                    resolve({duration : video.duration , size : file.size , isVideo : file.type.indexOf('video') != -1 })
                };
            }else{
                reject({duration : 0, size : file.size , isVideo : false })
            }

        })
    }

    setVideoIsNotUploadable(value : boolean){
        this.getTemplateViewModel().videoIsNotUploadable(value)
    }


    getVideoIsNotUploadable(){
        return this.getTemplateViewModel().videoIsNotUploadable()
    }

    setFileIsVideo(value: boolean){
        this.getTemplateViewModel().fileIsVideo(value)
    }

    getFileIsVideo(){
        return this.getTemplateViewModel().fileIsVideo()
    }

    getVideoBlob(){
        return this.getTemplateViewModel().videoBlob()
    }

    setVideoBlob(blob){
        this.getTemplateViewModel().videoBlob(blob)
    }


}



// WEBPACK FOOTER //
// ./vendor/valnet/valnet_imagePicker/js/components/templates/videoPickerAdd_template.ts